module.exports = __webpack_public_path__ + "epdf-app/dashboard/resumption/resumption-modal-alert-193l4m4N.html";